"use strict";

exports.__esModule = true;
exports.getAppSettingsValue = void 0;

var _lodash = require("lodash");

var _wixParamsSelectors = require("../../selectors/wix-params-selectors");

var getAppSettingsValue = function getAppSettingsValue(_ref) {
  var style = _ref.style,
      key = _ref.key,
      fallback = _ref.fallback,
      isMobileSettingsValue = _ref.isMobileSettingsValue,
      _ref$useDesktopFallba = _ref.useDesktopFallback,
      useDesktopFallback = _ref$useDesktopFallba === void 0 ? true : _ref$useDesktopFallba;
  return (0, _lodash.get)(style, (0, _wixParamsSelectors.getWixP)(key, isMobileSettingsValue), useDesktopFallback ? (0, _lodash.get)(style, (0, _wixParamsSelectors.getWixP)(key, false), fallback) : fallback);
};

exports.getAppSettingsValue = getAppSettingsValue;